import React, { type ReactNode } from 'react';
import { Banner } from '@talbenmoshe/trip-os-design-system';
import { SignInFailure, SignInNotice } from '@talbenmoshe/trip-os-react-model';
import { useMessages } from '../i18n/messagesContext.js';

export interface SignInNoticeBannerProps {
  failure: SignInFailure;
  notice: SignInNotice;
}

/**
 * The banner above a step's fields: a whole-step failure (expired, locked, too many codes, unreachable) or the
 * "new code sent" confirmation. Field-level failures (invalid email, wrong code) show under their field instead.
 */
export function SignInNoticeBanner({ failure, notice }: SignInNoticeBannerProps) {
  const messages = useMessages();
  let banner: ReactNode = null;

  if (failure === SignInFailure.CODE_EXPIRED) {
    banner = <Banner tone="error" title={messages.SIGN_IN_CODE_EXPIRED_TITLE()} body={messages.SIGN_IN_CODE_EXPIRED_BODY()} />;
  } else if (failure === SignInFailure.TOO_MANY_ATTEMPTS) {
    banner = <Banner tone="error" title={messages.SIGN_IN_TOO_MANY_ATTEMPTS_TITLE()} body={messages.SIGN_IN_TOO_MANY_ATTEMPTS_BODY()} />;
  } else if (failure === SignInFailure.TOO_MANY_CODES) {
    banner = <Banner tone="error" title={messages.SIGN_IN_TOO_MANY_CODES_TITLE()} body={messages.SIGN_IN_TOO_MANY_CODES_BODY()} />;
  } else if (failure === SignInFailure.UNAVAILABLE) {
    banner = <Banner tone="error" title={messages.SIGN_IN_UNAVAILABLE_TITLE()} body={messages.SIGN_IN_UNAVAILABLE_BODY()} />;
  } else if (notice === SignInNotice.NEW_CODE_SENT) {
    banner = <Banner tone="success" title={messages.SIGN_IN_NEW_CODE_SENT_TITLE()} body={messages.SIGN_IN_NEW_CODE_SENT_BODY()} />;
  }

  return banner;
}
